import { FC, useState } from "react";
import ShareholdersStore from "../../stores/ShareholdersStore";
import { observer } from "mobx-react";
import { isFailure, isOk, isPending } from "../../common/common";
import { Alert } from "../../components-v2/Alert";
import { Dialog } from "../../components-v2/Dialog";
import { VBox } from "../../components-v2/Box";

import { useTranslation } from "../../stores/RootStoreContext";

const RunAutoimportDialog: FC<{ controller: ShareholdersStore }> = observer(({ controller }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  return (
    <>
      {isOpen && (
        <Dialog
          submitLabel={
            controller.autoimportResult === undefined
              ? t("shareholders.autoimport.run")
              : t("close")
          }
          onSubmit={
            controller.autoimportResult === undefined
              ? controller.runAutoimport
              : () => {
                  setIsOpen(false);
                  window.location.reload();
                }
          }
          onCancel={controller.showCancelAutoimportButton() ? () => setIsOpen(false) : undefined}
          isSubmitting={isPending(controller.autoimportResult)}
          title={{ key: "shareholders.autoimport.title" }}
        >
          <VBox gap={"md"}>
            <div>{t("shareholders.autoimport.description")}</div>

            {isOk(controller.autoimportResult) && (
              <Alert type="success" message={t(controller.autoimportResult.data)} />
            )}
            {isFailure(controller.autoimportResult) && (
              <Alert type="error" message={t(controller.autoimportResult.error)} />
            )}
          </VBox>
        </Dialog>
      )}
    </>
  );
});

export default RunAutoimportDialog;
